import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/administration/account/audit-log/')({
  beforeLoad: () => {
    throw redirect({
      to: '/administration/account/audit-log/$page/$limit',
      params: { page: '1', limit: '10' },
    });
  },
});
